<template>
  <div>
    <div @mouseout="mouseOutMini" @mouseover="mouseOverMini">
      <v-navigation-drawer
        class="grey lighten-4"
        v-model="drawer"
        width="270"
        fixed
        app
        clipped
        :mini-variant="miniVariant"
      >
        <v-list dense>
          <template v-for="(menuItem, i) in menuItems">
            <v-layout row v-if="menuItem.heading" align-center :key="i">
              <v-flex xs6>
                <v-subheader v-if="menuItem.heading">{{
                  menuItem.heading
                }}</v-subheader>
              </v-flex>
            </v-layout>
            <v-divider
              dark
              v-else-if="menuItem.divider"
              class="my-3"
              :key="i"
            ></v-divider>
            <v-list-tile v-else :to="menuItem.link" :key="i">
              <v-list-tile-action class="align-center">
                <m-icon :icon="menuItem.name"></m-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{
                  $capitalizeName(menuItem.name)
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
      </v-navigation-drawer>
    </div>
    <v-toolbar
      style="background-image: linear-gradient(90deg, white, yellow 60%)"
      clipped-left
      app
    >
      <v-toolbar-side-icon @click="drawer = !drawer"></v-toolbar-side-icon>
      <a class="mt-1" @click="backToProject">
        <img class="mx-4" src="@/assets/tripko_logo.png" height="30px" />
      </a>

      <v-divider inset vertical></v-divider>

      <v-toolbar-title
        @click="backToCompany"
        v-if="!$store.state.client_status && !$isEmpty($store.state.company)"
      >
        <a class="black--text">{{ $store.state.company.name.toUpperCase() }}</a>
      </v-toolbar-title>

      <v-toolbar-title
        v-if="!$store.state.client_status && !$isEmpty($store.state.company)"
      >
        <v-icon slot="divider">arrow_right</v-icon>
      </v-toolbar-title>

      <v-toolbar-title
        @click="backToSubCompany"
        v-if="
          !$isEmpty($store.state.subcompany) && $store.state.company_menu.length
        "
      >
        <a :class="!$isEmpty($store.state.company) ? 'black--text' : ''">{{
          $store.state.subcompany.name.toUpperCase()
        }}</a>
      </v-toolbar-title>

      <v-toolbar-title v-if="!$isEmpty($store.state.booking_agent)">
        <v-icon slot="divider">arrow_right</v-icon>
      </v-toolbar-title>

      <v-toolbar-title v-if="!$isEmpty($store.state.booking_client)">
        <v-icon slot="divider">arrow_right</v-icon>
      </v-toolbar-title>

      <v-toolbar-title
        @click="backToBookingAgent"
        v-if="!$isEmpty($store.state.booking_agent)"
      >
        <a
          :class="!$isEmpty($store.state.booking_agent) ? 'black--text' : ''"
          >{{ $store.state.booking_agent.name.toUpperCase() }}</a
        >
      </v-toolbar-title>

      <v-toolbar-title
        @click="backToBookingAgent"
        v-if="!$isEmpty($store.state.booking_client)"
      >
        <a
          :class="!$isEmpty($store.state.booking_client) ? 'black--text' : ''"
          >{{ $store.state.booking_client.name.toUpperCase() }}</a
        >
      </v-toolbar-title>

      <v-toolbar-title
        v-if="
          !$isEmpty($store.state.subcompany) && $store.state.company_menu.length
        "
      >
        <v-icon slot="divider">arrow_right</v-icon>
      </v-toolbar-title>

      <v-toolbar-title class="ml-0 pl-3">
        <span
          :class="
            !$store.state.company_menu.length
              ? 'black--text'
              : !$isEmpty($store.state.company)
              ? 'white--text'
              : 'black--text'
          "
          >{{ $route.name ? $route.name.toUpperCase() : "" }}</span
        >
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-menu
        offset-y
        :close-on-content-click="false"
        :nudge-width="200"
        v-model="menu"
        bottom
        class="mr-2"
      >
        <v-avatar color="white" size="35px" slot="activator">
          <v-img :src="profilePic"></v-img>
          <!-- <span class="black--text title">{{ $firstLetter($store.state.employee.first_name) }}</span> -->
        </v-avatar>

        <v-card>
          <v-layout>
            <v-flex md4>
              <v-card-actions>
                <v-avatar color="black" tile size="80px">
                  <v-img :src="profilePic"></v-img>
                  <!-- <span class="white--text headline"> -->
                  <!-- <h1>{{ $firstLetter($store.state.employee.first_name) }}</h1> -->
                  <!-- </span> -->
                </v-avatar>
              </v-card-actions>
            </v-flex>

            <v-flex md8>
              <v-list two-line>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>{{
                      $store.state.employee.first_name +
                      " " +
                      $store.state.employee.last_name
                    }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{
                      $store.state.employee.email
                    }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>
          </v-layout>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn block color @click="settings" flat>Settings</v-btn>

            <v-btn block color @click="logout" flat>Log Out</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  props: {
    miniVariant: Boolean,
    menuItems: Array,
    profilePic: {
      type: String,
      default:
        "https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light",
    },
  },
  data() {
    return {
      drawer: true,
      menu: false,
      projectName: String,
    };
  },
  computed: {
    computedData() {
      return {
        project_name: this.projectName,
      };
    },
  },
  methods: {
    mouseOverMini() {
      this.$emit("mouseOverMini");
    },
    mouseOutMini() {
      this.$emit("mouseOutMini");
    },
    accountSettings() {
      this.$emit("accountSettings");
    },
    backToProject() {
      this.$emit("backToProject");
    },
    backToCompany() {
      this.$emit("backToCompany");
    },
    backToSubCompany() {
      this.$emit("backToSubCompany");
    },
    backToBookingAgent() {
      this.$emit("backToBookingAgent");
    },
    logout() {
      this.$emit("logout");
    },
    settings() {
      this.$emit("settings");
      this.menu = false;
    },
  },
};
</script>

<style scoped>
</style>
